import type { VirtualClinicAnalysisOperatingNumberTerm } from '../term/term';
import type {
  ShareableType,
} from '@bindoc-projects/resource-domain-lib';
import {
  BdChildResourceHelper
} from '@bindoc-projects/resource-domain-lib';
import type { Cloneable, OverrideProperty } from '@bindoc-projects/util-domain-lib';
import type {
  VirtualClinicAnalysisOperatingNumberTermSpec,
  VirtualClinicAnalysisOperatingNumberCalculationRequestPartBase,
} from '../../resolving';

export abstract class VirtualClinicAnalysisOperatingNumberCalculation
  implements Cloneable<VirtualClinicAnalysisOperatingNumberCalculation>
{
  public readonly type: 'benchmarking' | 'single-virtual-clinic';

  protected constructor(
    protected _term: VirtualClinicAnalysisOperatingNumberTerm,
  ) {}

  public toJSON(): {
    type: 'benchmarking' | 'single-virtual-clinic';
    term: VirtualClinicAnalysisOperatingNumberTermSpec | null;
  } {
    return {
      type: this.type,
      term: this._term ? this._term.toJSON() : null,
    };
  }

  public getChildResources(): {
    [resourceName in ShareableType]?: string[];
  } {
    let childResources = {};

    if (this._term) {
      childResources = BdChildResourceHelper.merge(
        childResources,
        this._term.getChildResources(),
      );
    }

    return childResources;
  }

  public isValid(): boolean {
    return !!this._term && this._term.isValid();
  }

  public abstract toRequestPart(): VirtualClinicAnalysisOperatingNumberCalculationRequestPartBase | null;

  public getOverrideProperties(
    tileId: string,
    dependencyVirtualClinicId: string = undefined,
  ): OverrideProperty[] {
    const result: OverrideProperty[] = [];

    if (this._term) {
      result.push(
        ...this._term.getOverrideProperties(tileId, dependencyVirtualClinicId),
      );
    }

    return result;
  }

  public abstract clone(): VirtualClinicAnalysisOperatingNumberCalculation;

  public abstract overrideClone(
    override: OverrideProperty[],
  ): VirtualClinicAnalysisOperatingNumberCalculation;

  get term(): VirtualClinicAnalysisOperatingNumberTerm {
    return this._term;
  }

  set term(value: VirtualClinicAnalysisOperatingNumberTerm) {
    this._term = value;
  }
}
